import { BandConfigurationOption } from '@beatgig/api-services'

const DefaultBandConfiguration = BandConfigurationOption.FULL_BAND

export default DefaultBandConfiguration
